<template>
  <div class="machinery_num">
    <div class="zhilian">
      <div class="item">
        <div class="item_title">
          <p>
            <img src="../../../../static/img/icon3.png" alt="">
            <img src="../../../../static/img/icon2.png" alt="">
            <img src="../../../../static/img/icon1.png" alt="">
          </p>
          <span class="tit_class">全部农机统计
          	<!--<img src="../../../../static/img/zhiliannongji-right-icon.png" alt="">-->
          	</span>
        </div>
        <p class="img_right2"><span>单位：台</span></p>
      </div>
    </div>
    <div class="ng-type">
      <div class="table_title">
        <span>农机</span>
        <span>农机总量</span>
        <span>智联农机</span>
        <span>当日开机</span>
      </div>
    </div>
    <!--<div class="InfiniteScroll">
      <div class="scroll_parent_box" @mouseenter="mEnterReceive" @mouseleave="mLeaveReceive">
        <div class="scroll_list dataList" :style="{ transform: `translate(0px,-${scrollTopReceive}px)` }">
          <div ref="scrollItemBoxReceive">
            <li v-for="(item, index) in listData" :key="index">
              {{item}}
            </li>
          </div>
          <div v-html="copyHtmlReceive"></div>
        </div>
      </div>
    </div>-->
    <div :class="[dataListClass,'items0']">
      <p>
        <img src="../../../../static/img/nj-img/class_all_icon.png" alt="">
        <span>{{ allDataList.catThreeName }}</span>
      </p>
      <p>{{ allDataList.njNum }}</p>
      <p>{{ allDataList.zlNum }}</p>
      <p>{{ allDataList.kjNum }}</p>
    </div>
    <div class="InfiniteScroll">
      <div class="scroll_parent_box" @mouseenter="mEnter" @mouseleave="mLeave">
        <div class="scroll_list dataList" :style="{ transform: `translate(0px,-${scrollTop}px)` }">
          <div ref="scrollItemBox">
            <div v-for="(item, index) in dataList" :key="index" :class="[dataListClass,'items'+item.icon]">
              <p>
                <img :src="item.img" alt="">
                <!-- <span>自走式玉米收获机</span> -->
                <span>{{ item.catThreeName }}</span>
              </p>
              <p>{{ item.njNum }}</p>
              <p>{{ item.zlNum }}</p>
              <p>{{ item.kjNum }}</p>
            </div>
          </div>
          <div v-html="copyHtml"></div>
        </div>
      </div>
    </div>
    <!-- <div :class="dataContentClass">
      <div v-for="(item, index) in dataList"  :class="[dataListClass,'items'+item.catThreeCode]" :key="index">
        <p>
          <img :src="item.img" alt="">
          <span>{{ item.catThreeName }}</span>
        </p>
        <p>{{ item.njNum }}</p>
        <p>{{ item.zlNum }}</p>
        <p>{{ item.kjNum }}</p>
      </div>
    </div> -->
  </div>
</template>
<script>
import  Api from '../../../Serves/net-api.js'
import Http from '../../../Serves/net-http.js'
import {mapState,mapActions,mapMutations} from "vuex";
let timer;
export default {
  components: {},
  data () {
    return {
      dataListClass: '',
      dataContentClass: '',
      dataList: [],
      scrollTop: 0, //列表滚动高度
      speed: 26, //滚动的速度
      copyHtml: '', //复制多一份防止滚动到后面出现空白
      timeList:[],
      allDataList: {}
    }
  },
  mounted () {
    var pathname = window.location.pathname.substring(0,5)
    var port = window.location.port
    this.dataListClass = 'data_list'
    this.dataContentClass = 'data_content'
    this.countNjNum()
  },
  methods: {
    initScroll() {
      this.copyHtml = this.$refs.scrollItemBox.innerHTML
      this.startScroll()
    },
   
    
    
    // 鼠标移入停止滚动
			mEnter() {
				for(let i = 0; i < this.timeList.length; i++) {
					window.clearInterval(this.timeList[i])
				}
			},
			// 鼠标移出继续滚动
			mLeave() {
        if (this.dataList.length>4) {
          this.$nextTick(() => {
            this.startScroll()
          })
        }
			},
    
    // 开始滚动
    startScroll() {
      if(this.dataList.length > this.dataList.length-1) {
        let timer = window.setInterval(this.scroll, this.speed);
				this.timeList.push(timer)
      }
    },
    // 滚动处理方法
    scroll() {
      this.scrollTop++
      // 获取需要滚动的盒子的高度
      let scrollItemBox = this.$refs.scrollItemBox ? this.$refs.scrollItemBox.offsetHeight : 0
      // 当判断滚动的高度大于等于盒子高度时，从头开始滚动
      if(this.scrollTop >= scrollItemBox) {
        this.scrollTop = 0
      }
    },
    countNjNum(){
      var url=Http.test+'/homePageStatis/getNjStatisticsByMachinery'
      Api.doPost(url,null,false,(res)=>{
        this.allDataList = res.result[0]
        var arr = res.result.slice(1)
        this.dataList = arr
        arr.forEach((item,index) => {
        	if (item.icon == 0) {
        		item.img = '../../../../static/img/nj-img/class_all_icon.png'
        	} else if (item.icon == 1) {
        		item.img = '../../../../static/img/nj-img/class_tlj_icon.png'
        	}	else if (item.icon == 2) {
        		item.img = '../../../../static/img/nj-img/class_lvdai_icon.png'
        	}	else if (item.icon == 3) {
        		item.img = '../../../../static/img/nj-img/class_xgj_icon.png'
        	} else if (item.icon == 4) {
        		item.img = require('../../../assets/img/icon/gengzuo_fenlei.png')
        	} else if (item.icon == 5) {
            item.img = require('../../../assets/img/icon/chayang_fenlei.png')
        	} else if (item.icon == 6) {
        		item.img = require('../../../assets/img/icon/paoyang_fenlei.png')
        	} else if (item.icon == 7) {
        		item.img = require('../../../assets/img/icon/xuebo_fenlei.png')
        	} else if (item.icon == 8) {
        		item.img = require('../../../assets/img/icon/yizai_fenlei.png')
        	} else if (item.icon == 9) {
        		item.img = '../../../../static/img/nj-img/class_pwj_icon.png'
        	} else if (item.icon == 10) {
        		item.img = require('../../../assets/img/icon/wurenji_fenlei.png')
        	}	else if (item.icon == 11) {
        		item.img = '../../../../static/img/nj-img/class_gws_icon.png'
        	}	else if (item.icon == 12) {
        		item.img = '../../../../static/img/nj-img/class_ymsh_icon.png'
        	} else if (item.icon == 13) {
        		item.img = require('../../../assets/img/icon/hss_fenlei.png')
        	} else if (item.icon == 14) { // 薯类收获机
        		item.img = require('../../../assets/img/icon/shuleish_fenlei.png')
        	} else if (item.icon == 15) { 
        		item.img = '../../../../static/img/nj-img/class_ycz_icon.png'
        	} else if (item.icon == 16) {
        		item.img = require('../../../assets/img/icon/gzs_fenlei.png')
        	} else if (item.icon == 17) {
        		item.img = require('../../../assets/img/icon/mhs_fenlei.png')
        	} else if (item.icon == 18) { // 果类收获机
        		item.img = require('../../../assets/img/icon/guoleiish_fenlei.png')
        	} else if (item.icon == 19) {
        		item.img = '../../../../static/img/nj-img/class_sls_icon.png'
        	} else if (item.icon == 20) {
            item.img = require('../../../assets/img/icon/dakun_fenlei.png')
        	} else if (item.icon == 21) {
            item.img = require('../../../assets/img/icon/geshai_fenlei.png')
        	} else if (item.icon == 22) {
            item.img = require('../../../assets/img/icon/fzjs.png')
        	} else if (item.icon == 23) {
            item.img = require('../../../assets/img/icon/czs_fenlei.png')
        	} else if (item.icon == 24) {
            item.img = require('../../../assets/img/icon/icon_pingdi.png')
        	}
        })
        if (this.dataList.length>4) {
          this.$nextTick(() => {
            this.initScroll()
          })
        }
        this.bus.$emit('mapVal', res.result[0])
      })
    }
  }
}
</script>
<style scoped>
  .InfiniteScroll {
		box-sizing: border-box;
	}
	
	.scroll_parent_box {
		width: 100%;
		height: 43vh;
    height: 34vh;
		overflow: hidden;
		box-sizing: border-box;
	}
	
	.scroll_list {
		transition: all 0ms ease-in 0s
	}
	
	.scroll_item {
		height: 40px;
		line-height: 40px;
		text-align: center;
		font-size: 14px;
	}
  /*里面的代码可以根据自己需求去进行更改*/
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width:3px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
  border-radius:10px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius:10px;
  background:#0A63C6;
  -webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
}
/* ::-webkit-scrollbar-thumb:window-inactive {
background:rgba(255,0,0,0.4);
} */
  .machinery_num{
    width: 100%;
  }
  .zhilian{
    position: relative;
    height: 20%;
  }
  .danwei{
    position: absolute;
    right: 19px;
    top: 2vh;
    font-size: 14px;
    color: #9DDBE9;
    line-height: 14px;
  }
  .item{
    height: 4.6vh;
    line-height: 4.6vh;
    display: flex;
    justify-content: space-between;
    padding: 0 1vw;
  }
  .item_title{
    display: flex;
  }
  .item_title p{
    margin-top: 0.2vh;
  }
  
  .item_title span{
    font-size: 0.9vw;
    font-weight: bold;
    color: #ffffff;
    font-family: '微软雅黑';
    margin-left: 0.5vw;
  }
  .tit_class{
    width: 85%;
  }
  .tit_class span{
    font-size: 20px;
  }
  .tit_class img{
    width: 60%;
  }
 
  .img_right2 span{
    float: right;
    color: #81D4FF;
  }
  .ng-type{
    width: 100%;
  }
  .table_title{
    width: 96%;
    height: 50px;
    line-height: 50px;
    background: #010C79;
    border-radius: 4px;
    margin: 0 auto;
    /* margin-left: 16px; */
  }
  .table_title span{
    display: inline-block;
    text-align: center;
    line-height: 3.2vh;
    font-size: 16px;
    font-family: Microsoft YaHei;
    /* font-weight: 400; */
    color: #11BEF7;
  }
  .table_title span:nth-child(1){
    width: 30%;
  }
  .table_title span:nth-child(2){
    width: 23%;
  }
  .table_title span:nth-child(3){
    width: 24%;
  }
  .table_title span:nth-child(4){
    width: 19%;
  }
  .data_content{
    width: 100%;
    height: 43vh;
    /*overflow: hidden;*/
  }
  .data_list{
    margin: 0 auto;
    width: 96%;
    /* height: 20%; */
    /* height: 80px; */
    /* height: 7.6vh; */
    /* line-height: 8vh; */
    margin-top: 10px;
    background: rgb(1, 12, 121, .34);
    /* opacity: 0.34; */
    border-radius: 4px;
    display: flex;
  }
  /* .data_list p:after{     
    content:"";
    display: inline-block;
    position: absolute;
    top: 30px;
    right: 0px;
    width: 1px;
    height: 20px;
    background-color: #063045;
  } */
  .data_list p:nth-child(1){
    text-align: center;
  }
  .data_list p:nth-child(2), .data_list p:nth-child(3), .data_list p:nth-child(4){
    text-align: center;
    font-weight: bold;
  }
  .data_list p{
    font-size: 14px;
    position: relative;
  }
  .items0 p img{
    width: 36px;
    position: absolute;
    left: 48px;
    top: 1vh;
  }
  .items1 p img{
    width: 38px;
    position: absolute;
    left: 45px;
    top: 1vh;
  }
  .items2 p img{
    width: 43px;
    position: absolute;
    top: 1vh;
    left: 45px;
  }
  .items3 p img{
    width: 44px;
    position: absolute;
    left: 45px;
    top: 1vh;
  }
  .items4 p img{
    width: 50px;
    position: absolute;
    left: 45px;
    top: 1vh;
  }
  .items5 p img{
    width: 50px;
    position: absolute;
    left: 40px;
    top: 1.7vh;
  }
  .items6 p img{
    width: 45px;
    position: absolute;
    left: 45px;
    top: 0.8vh;
  }
  .items7 p img{
    width: 53px;
    position: absolute;
    left: 43px;
    top: 1.2vh;
  }
  .items8 p img{
    width: 53px;
    position: absolute;
    left: 43px;
    top: 1.2vh;
  }
  .items9 p img{
    width: 53px;
    position: absolute;
    left: 43px;
    top: 1.2vh;
  }
  .items10 p img{
    width: 48px;
    position: absolute;
    left: 43px;
    top: 1.2vh;
  }
  .items11 p img{
    width: 45px;
    position: absolute;
    left: 45px;
    top: 1.2vh;
  }
  .items12 p img{
    width: 45px;
    position: absolute;
    left: 45px;
    top: 1vh;
  }
  .items13 p img{
    width: 50px;
    position: absolute;
    left: 45px;
    top: 1vh;
  }
  .items14 p img{
    width: 52px;
    position: absolute;
    left: 40px;
    top: 1.7vh;
  }
  .items15 p img{
    width: 50px;
    position: absolute;
    left: 45px;
    top: 1vh;
  }
  .items16 p img{
    width: 40px;
    position: absolute;
    left: 45px;
    top: 1vh;
  }
  .items17 p img{
    width: 50px;
    position: absolute;
    left: 45px;
    top: 1vh;
  }
  .items18 p img{
    width: 50px;
    position: absolute;
    left: 42px;
    top: 1.6vh;
  }
  .items19 p img{
    width: 50px;
    position: absolute;
    left: 42px;
    top: 1vh;
  }
  .items20 p img{
    width: 50px;
    position: absolute;
    left: 42px;
    top: 1vh;
  }
  .items21 p img{
    width: 50px;
    position: absolute;
    left: 42px;
    top: 1.5vh;
  }
  .items22 p img{
    width: 40px;
    position: absolute;
    left: 42px;
    top: 0.5vh;
  }
  .items23 p img{
    width: 50px;
    position: absolute;
    left: 42px;
    top: 0.7vh;
  }
  .items24 p img{
    width: 60px;
    position: absolute;
    left: 42px;
    top:1.7vh;
  }

  .data_list p{
    color: #00CCFF;
  	
  }
  .data_list p span{
    text-align: center;
    /* line-height: 12vh; */
    font-size: 14px;
    color: #00CCFF;
    width: 6vw;
    display: inline-block;
    padding-top: 4.5vh;
  }
  .data_list p:nth-child(1){
    width: 34%;
    /* line-height: 7.8vh; */
  }
  .data_list p:nth-child(2){
    width: 23%;
    font-size: 20px;
    line-height: 7.8vh;
  }
  .data_list p:nth-child(3){
    width: 28%;
     font-size: 20px;
    line-height: 7.8vh;
  }
  .data_list p:nth-child(4){
    width: 20%;
     font-size: 20px;
    line-height: 7.8vh;
  }

  .data_content1{
    width: 100%;
    height: 50vh;
  }
  .data_list1{
    margin: 0 auto;
    width: 92%;
    height: 9vh;
    /* line-height: 7.7vh; */
    margin-top: 1.3vh;
    background: rgba(4, 188, 210, 0.15);
    border-radius: 4px;
    display: flex;
  }
  .data_list1 p{
    text-align: center;
    font-family: Microsoft YaHei;
    /* font-weight: bold; */
  }
  .data_list1 p{
    font-size: 14px;
    position: relative;
  }
  .data_list1:nth-child(1) p img{
    width: 27px;
    height: 2.2vh;
    position: absolute;
    top: 2.3vh;
    left: 28px;
  }
  .data_list1:nth-child(2) p img{
    width: 37px;
    height: 2.3vh;
    position: absolute;
    top: 2.3vh;
    left: 22px;
  }
  .data_list1:nth-child(3) p img{
    width: 34px;
    height: 2.4vh;
    position: absolute;
    top: 2.3vh;
    left: 23px;
  }
  .data_list1:nth-child(4) p img{
    width: 47px;
    height: 1.8vh;
    position: absolute;
    top: 2.3vh;
    left: 18px;
  }
  .data_list1:nth-child(5) p img{
    width: 38px;
    height: 2.2vh;
    position: absolute;
    top: 2.3vh;
    left: 20px;
  }
  .data_list1 p span{
    text-align: center;
    line-height: 12vh;
    font-size: 14px;
  }
  .data_list1:nth-child(1) p span{
    color: #00B7EE;
  }
  .data_list1:nth-child(2) p span{
    color: #8FC31F;
  }
  .data_list1:nth-child(3) p span{
    color: #F8F36A;
  }
  .data_list1:nth-child(4) p span{
    color: #32F489;
  }
  .data_list1:nth-child(5) p span{
    color: #FFB400;
  }
  .data_list1 p:nth-child(1){
    width: 25%;
  }
  .data_list1 p:nth-child(2){
    width: 19%;
    font-size: 22px;
    color: #00F0F9;
    line-height: 9vh;
  }
  .data_list1 p:nth-child(3){
    width: 28%;
    font-size: 22px;
    color: #00F0F9;
    line-height: 9vh;
  }
  .data_list1 p:nth-child(4){
    width: 20%;
    font-size: 22px;
    color: #00F0F9;
    line-height: 9vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index/view/AgriculturalMachinery.vue